import Resource from './Resource';

export default class Assessments extends Resource {
	constructor(options={}) {
		let {
			route = '',
			query = {}
		} = options;

		let config = {
			route: route,
			query: query,
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
